import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import kitchenAdmin from "../../../../apis/admin/kitchenService";

type KitchenListState = {
	kitchens: [];
	isLoading: boolean;
	kitchen: number;
};

const initialState: KitchenListState = {
	kitchens: [],
	isLoading: false,
	kitchen: 0,
};

export const getUserDatas = createAsyncThunk(
	"kitchen/fetchKitchen",
	async ({
		status,
		value,
		isDisable = false,
	}: {
		status: any;
		value: string;
		isDisable?: boolean;
	}) => {
		const response: any = await kitchenAdmin.getKitchenData(
			status,
			value,
			isDisable
		);

		return response?.data?.data?.payload;
	}
);
export const getKittenDefault = createAsyncThunk(
	"kitchen/getKittenDefault",
	async () => {
		const response: any = await kitchenAdmin.kitchenDefault();
		return response?.data?.data?.payload;
	}
);

export const kitchenSlice = createSlice({
	name: "kitchenlist",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getUserDatas.pending, (state) => {
				state.isLoading = false;
				state.kitchens = [];
			})
			.addCase(getUserDatas.fulfilled, (state, { payload }) => {
				state.isLoading = true;
				state.kitchens = payload;
			})
			.addCase(getUserDatas.rejected, (state) => {
				state.isLoading = false;
				state.kitchens = [];
			})
			.addCase(getKittenDefault.fulfilled, (state, { payload }) => {
				state.kitchen = payload.kitchenId;
			});
	},
});

export default kitchenSlice.reducer;
